import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "gap"];
import styled from 'styled-components';
import { makeCustomProperty } from './utils';
import { LayoutBox } from './LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const SpacingContainer = styled(LayoutBox).withConfig({
  displayName: "LayoutSpaceVertical__SpacingContainer",
  componentId: "sc-4tdr1v-0"
})([">:not(:last-child){", " margin-block-end:var(--layout-lib-space-gap);}"], ({
  $gap
}) => `--layout-lib-space-gap: ${makeCustomProperty($gap)};`);
export const LayoutSpaceVertical = _ref => {
  let {
      as,
      children,
      gap = 'space-lg'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SpacingContainer, Object.assign({}, rest, {
    $gap: gap,
    forwardedAs: as,
    children: children
  }));
};